export const urkSubMenu = {
  export: { title: "Експорт", link: "#" },
  forbusiness: "Для бізнесу",
  forbusinessLink: "/for-business/",
  foryou: "Для тебе",
  foryouLink: "/for-you/",
  import: { title: "Імпорт", link: "#" },
  list: [
    { title: "Особистий кабінет", link: "https://my.nova.global?lang=ua-uk" },
    { title: "Трекінг", link: "/track/" },
    { title: "Продукти і сервіси", link: "/products-services" },
    { title: "Шопінг", link: "https://npshopping.com" },
    { title: "Хто ми", link: "/about" },
    { title: "Кар׳‌єра", link: "/career" },
    { title: "Новини", link: "/news" },
    { title: "Контакти", link: "/contact" },
  ],
  recieve: { title: "Отримання", link: "#" },
  send: { title: "Відправлення", link: "#" },
};

export const enSubMenu = {
  export: { title: "Export", link: "#" },
  forbusiness: "For business",
  foryou: "For you",
  forbusinessLink: "/en/for-business/",
  foryouLink: "/en/for-you/",

  import: { title: "Import", link: "#" },
  list: [
    { title: "Personal account", link: "https://my.nova.global?lang=ua-en" },
    { title: "Tracking", link: "/en/track/" },
    { title: "Products and services", link: "/en/products-services" },
    { title: "Shopping", link: "https://npshopping.com" },
    { title: "Who we are", link: "/en/about" },
    { title: "Career", link: "/en/career" },
    { title: "News", link: "/en/news" },
    { title: "Contacts", link: "/en/contact" },
  ],
  recieve: { title: "Receiving", link: "#" },
  send: { title: "Sending", link: "#" },
};

export const ruSubMenu = {
  export: { title: "Экспорт", link: "#" },
  forbusiness: "Для бизнеса",
  foryou: "Для тебя",
  forbusinessLink: "/ru/for-business/",
  foryouLink: "/ru/for-you/",
  import: { title: "Импорт", link: "#" },
  list: [
    { title: "Личный кабинет", link: "https://my.nova.global?lang=ua-ru" },
    { title: "Трекинг", link: "/ru/track/" },
    { title: "Продукты и сервисы", link: "/ru/products-services" },
    { title: "Шопинг", link: "https://npshopping.com" },
    { title: "Кто мы", link: "/ru/about" },
    { title: "Карьера", link: "/ru/career" },
    { title: "Новости", link: "/ru/news" },
    { title: "Контакты", link: "/ru/contact" },
  ],
  recieve: { title: "Получение", link: "#" },
  send: { title: "Отправление", link: "#" },
};
